// extracted by mini-css-extract-plugin
export default {"wrapper":"qT-z","availablePromoMessagesLabel":"rT-z","promoMessageList":"sT-z","promoMessage":"tT-z","appliedPromoMessage":"uT-z","promoMessageAmount":"vT-z"};